/**
 * Process status enum for forecasting processes
 */
export enum ProcessStatus {
    CREATED = 'CREATED',
    CONSOLIDATED = 'CONSOLIDATED', 
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED'
}
